import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import localeCs from 'date-fns/locale/cs';
import Loading from 'components/Loading/index';
import api from 'api';
import Util from 'utility';
import { __ } from 'locale';
import FoodRow from 'components/Recipe/RecipeEditor/FoodRow/index';
import EvaluationPanelContents from 'components/EvaluationPanel/EvaluationPanelContents';

function SeminarWorkLongtermEvaluation() {
    const data = useSelector(state => state);
    const { globals } = data;

    const [graphType, setGraphType] = useState('bar');
    const [evaluationResult, setEvaluationResult] = useState(null);
    const [dayDetailDate, setDayDetailDate] = useState(null);
    const [dayState, setDayState] = useState({});
    const [dayEvaluation, setDayEvaluation] = useState({});
    const [selectedAttribute, setSelectedAttribute] = useState('');
    const [viewType, setViewType] = useState('evaluation');
    const [loading, setLoading] = useState(false);

    const generateLongTermEvaluation = () => {
        const profileId = typeof data.appModeData.profileId === 'number'
            ? data.appModeData.profileId
            : Util.getActiveProfileId();

        setLoading(true);
        api('evaluation/seminar-work-long-term', {
            post: true,
            data: {
                lectureId: data.appModeData.lectureId,
                profileId,
                type: graphType,
            }
        }).then(result => {
            setEvaluationResult(result.data);
        }).finally(() => {
            setLoading(false);
        });
    };

    let content;

    if(loading) {
        content = <Loading />;
    } else if(viewType == 'evaluation') {
        content = (
            <>
                <div className="flex items-center gap-[1em] mb-[1em]">
                    <div className="">
                        <label className="mr-4"><input checked={graphType == 'bar'} onChange={e => setGraphType(e.target.value)} type="radio" name="type" value="bar" /> {__('sloupcový')}</label>
                        <label><input checked={graphType == 'line'} onChange={e => setGraphType(e.target.value)} type="radio" name="type" value="line" /> {__('čárový')}</label>
                    </div>
                    <div className="">
                        <button className="bg-[#26AA52] text-white py-[0.5em] px-[1em] rounded cursor-pointer border-none hover:bg-[#2dcb62]" onClick={generateLongTermEvaluation}>{__('Zobrazit vyhodnocení')}</button>
                    </div>
                </div>
                {evaluationResult && <div dangerouslySetInnerHTML={{ __html: evaluationResult.html }}></div>}
            </>
        );
    } else {
        // day-detail
        const currentDayState = dayState.state || {};
        const mealsList = [];

        for(let m in currentDayState.meals) {
            const foodGroups = [];
            for(let g in currentDayState.groups?.[m]) {
                const group = { ...currentDayState.groups[m][g], id: g };
                const foods = Object.values(currentDayState.foods?.[m] || {})
                    .filter(f => f.group_id == group.id)
                    .map(f => {
                        const food = { ...f, food_id: f.item_id, image: `https://www.zofapp.cz/data/zof/item/${f.item_id}.svg` };
                        return <FoodRow food={food} key={food.id} readOnly={true} />;
                    });
                foodGroups.push(
                    <div className="mb-[1em]" key={g}>
                        <h3>{globals.foodGroupTypes[group.type]}: {group.title}</h3>
                        {foods}
                    </div>
                );
            }

            const meal = currentDayState.meals[m];
            const mealProfiles = meal.profile_ids.split(',').map(profileId => {
                const p = globals.profiles[profileId];
                if(!p?.name) return null;
                const profileColor = p.color || '999999';
                return <span key={profileId} style={{ color:'#fff', padding:'3px 5px', borderRadius:'3px', marginRight:'.25em', backgroundColor:'#'+profileColor }}>{p.name}</span>;
            }).filter(Boolean);

            let sh = '' + meal.startHour; if(sh.length < 2) sh = '0' + sh;
            let sm = '' + meal.startMinute; if(sm.length < 2) sm = '0' + sm;

            mealsList.push(
                <div className="mb-[2em] pb-[1em] border-b border-[#eee]" key={m}>
                    <h2><b>{sh}:{sm} | {globals.mealTypes[meal.meal_id].title}</b>{'\u00A0'}<span>{mealProfiles}</span></h2>
                    {foodGroups}
                </div>
            );
        }

        const dateText = format(dayDetailDate, 'EEEE d. M. yyyy', { locale: localeCs });

        content = (
            <>
                <p style={{margin:'.5em 0 1 0',fontSize:'.85em',display:'flex'}}>
                    <a style={{background:'#4eb32d',color:'#fff',borderRadius:'4px',padding:'.5em 1.25em',textDecoration:'none'}} onClick={() => { setSelectedAttribute(''); setViewType('evaluation'); }}><i className="fa fa-angle-left"></i> Zpět</a>
                </p>
                <h2 style={{margin:'0 0 1em 0',fontSize:'1.6em'}}>Detail dne {dateText}</h2>
                <div style={{display:'flex'}}>
                    <div>{mealsList.length > 0 ? mealsList : <p>Nemáte zadány žádné chody / recepty.</p>}</div>
                    <div style={{flexBasis:'300px',flexShrink:'0'}}>
                        <EvaluationPanelContents wholeDay={true} mainStyle={{display:'block'}} results={dayEvaluation.evaluation} ddd={dayEvaluation.ddd} quickresults={false} />
                    </div>
                </div>
            </>
        );
    }

    return content;
}

export default SeminarWorkLongtermEvaluation;
